import { createFormSnippetGroup } from '@ipfabric/ui-components/utils/formSnippets/FormSnippetGroup';
import { SearchableSection } from '../../../components/DiscoverySearch/SearchableSection';
import { disabledDiscoveryTasks } from '../../../snippets/disabledDiscoveryTasks';
import type { DiscoverySettingsGroupDisplayControl } from '../DiscoverySettings';

export const disabledDiscoveryTasksGroup = createFormSnippetGroup({
  snippets: {
    disabledDiscoveryTasks,
  },
  render: ({ renderSnippet }) => (
    // must be in a flex column so the table stretches to full height
    <div className='flex-1 flex flex-col gap'>
      <div className='text-default text-level-4 font-semibold font-heading'>
        Disabled discovery tasks
      </div>
      <div className='flex-1 flex flex-col rounded-lg bg-default'>
        <SearchableSection
          id='disabled-discovery-tasks'
          searchTerms={['Rule list']}
          highlightOn={['disabledDiscoveryTasks']}
          className='flex-1 flex flex-col'
          wrapperClassName='flex-1 flex flex-col'
        >
          {renderSnippet('disabledDiscoveryTasks')}
        </SearchableSection>
      </div>
    </div>
  ),
  show: (control: DiscoverySettingsGroupDisplayControl) => {
    control.setTab('disabledDiscoveryTasks');
  },
});
